import { render, staticRenderFns } from "./BrokerNav.vue?vue&type=template&id=965282ec"
import script from "./BrokerNav.vue?vue&type=script&lang=js"
export * from "./BrokerNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports